import { login, wxlogin, refreshToken } from '@/api/login'
import { getCookie, setCookie, removeCookie } from '@/utils/auth'
import { timestampToTime3 } from '@/utils/timestamp'

const user = {
  state: {
    token: getCookie('token'),
    nickname: getCookie('nickname'), // 昵称
    name: getCookie('name') // 登录名
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK_NAME: (state, nickname) => {
      state.nickname = nickname
    }
  },

  actions: {
    // 用户密码登录
    Login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data.username, data.password, data.customerId).then(response => {
          setCookie('token', response.accessToken, 2)
          setCookie('userid', response.userid)
          setCookie('userType', response.userType)
          setCookie('nickname', response.name)
          setCookie('name', response.login)
          setCookie('head', response.head)
          // setCookie('customerId', response.customerId)
          setCookie('tokentime', timestampToTime3(new Date()))
          setCookie('regionLevel', response.regionLevel)
          if (response.userType === 0) {
            setCookie('redirectUrl', 'dashboard')
          } else {
            if (response.url === null || response.url === '') {
              setCookie('redirectUrl', 'dashboard')
            } else {
              setCookie('redirectUrl', response.url)
            }
          }
          commit('SET_TOKEN', response.accessToken)
          commit('SET_NAME', response.name)
          resolve(response.accessToken)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 微信登录
    wxLogin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        wxlogin(data.code).then(response => {
          if (response) {
            setCookie('token', response.accessToken, 2)
            setCookie('userid', response.userid)
            setCookie('userType', response.userType)
            setCookie('nickname', response.name)
            setCookie('name', response.login)
            setCookie('head', response.head)
            setCookie('customerId', response.customerId)
            setCookie('tokentime', timestampToTime3(new Date()))
            if (response.url === null || response.url === '') {
              setCookie('redirectUrl', 'dashboard')
            } else {
              setCookie('redirectUrl', response.url)
            }
            commit('SET_TOKEN', response.accessToken)
            commit('SET_NAME', response.name)
          }
          resolve(response.accessToken)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 刷新token
    refreshToken ({ commit }, data) {
      return new Promise((resolve, reject) => {
        refreshToken(data.login, data.name).then(response => {
          setCookie('token', response.accessToken, 2)
          setCookie('tokentime', timestampToTime3(new Date()))
          commit('SET_TOKEN', response.accessToken)
          resolve(response.accessToken)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeCookie('token')
        removeCookie('userid')
        removeCookie('userType')
        removeCookie('nickname')
        removeCookie('name')
        removeCookie('tokentime')
        removeCookie('head')
        removeCookie('customerId')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js